module.exports = __webpack_public_path__ + "img/3.8c2b996e.webp";